import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import State from '../states'
import SignUpPromoteModal, { Props } from '../components/SignUpPromoteModal'
import { Toolbar } from '../actions'

const mapStateToProps = (state: State): Partial<Props> => ({
  isOpen: state.ui.showSignUpPromoteModal
})

const mapDispatchToProps = (dispatch: Dispatch<State>): Partial<Props> => ({
  onSignUp: () => {
    dispatch(Toolbar.signUpPromoteTapped())
  },
  onClose: () => {
    dispatch(Toolbar.closeSignUpPromoteModal())
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPromoteModal)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SignUpPromoteModal.ts